import * as WildlifeActions from '~app/actions/wildlife';
import makeReducer from '~app/core/makeReducer';

const initialState = {
  speciesList: [],

  activeClassFilter: WildlifeActions.WildlifeClass.mammal,
  activeThreatFilter: WildlifeActions.ThreatLevel.all,
  filteredSpecies: [],

  selectedSpeciesSummary: null,
  selectedSpeciesContent: null,
  selectedSpeciesImage: null,
};

function setSpeciesList(state, {speciesList, countAmphibians, countMammals, countReptiles}) {
  return {
    ...state,
    speciesList,
    countAmphibians,
    countMammals,
    countReptiles,
  };
}

function setClassFilter(state, {classFilter}) {
  return {
    ...state,
    activeClassFilter: classFilter,
  };
}

function setThreatFilter(state, {threatFilter}) {
  return {
    ...state,
    activeThreatFilter: threatFilter,
  };
}

function setFilteredSpecies(state, {filteredSpecies}) {
  return {
    ...state,
    filteredSpecies,
  };
}

function setThreatLevelCounts(state, {threatLevelCounts}) {
  return {
    ...state,
    threatLevelCounts,
  };
}

function selectSpecies(state, {summary}) {
  return {
    ...state,
    selectedSpeciesSummary: summary,
  };
}

function loadedSpeciesContent(state, {content}) {
  return {
    ...state,
    selectedSpeciesContent: content,
  };
}

function loadedSpeciesImage(state, {imageObjectUrl, binomial}) {
  if (state.selectedSpeciesContent.binomial !== binomial) {
    // This is a load that came in too late, so ignore it.
    return state;
  }

  return {
    ...state,
    selectedSpeciesImage: imageObjectUrl,
  };
}

function clearSpeciesImage(state) {
  return {
    ...state,
    selectedSpeciesImage: null,
  };
}

function clearSelectedSpecies(state) {
  return {
    ...state,
    selectedSpeciesSummary: null,
    selectedSpeciesContent: null,
    selectedSpeciesImage: null,
  };
}

const ACTION_HANDLERS = {
  [WildlifeActions.SET_SPECIES_LIST]: setSpeciesList,
  [WildlifeActions.SET_CLASS_FILTER]: setClassFilter,
  [WildlifeActions.SET_THREAT_FILTER]: setThreatFilter,
  [WildlifeActions.SET_FILTERED_SPECIES]: setFilteredSpecies,
  [WildlifeActions.SET_THREAT_LEVEL_COUNTS]: setThreatLevelCounts,
  [WildlifeActions.SELECT_SPECIES]: selectSpecies,
  [WildlifeActions.LOADED_SPECIES_CONTENT]: loadedSpeciesContent,
  [WildlifeActions.LOADED_SPECIES_IMAGE]: loadedSpeciesImage,
  [WildlifeActions.CLEAR_SPECIES_IMAGE]: clearSpeciesImage,
  [WildlifeActions.CLEAR_SELECTED_SPECIES]: clearSelectedSpecies,
};

export default makeReducer(ACTION_HANDLERS, initialState);



// WEBPACK FOOTER //
// ./src/store/wildlifeReducer.js